module.exports = __webpack_public_path__ + "img/xml.b1714cb4.svg";